// extracted by mini-css-extract-plugin
var _1 = "BoardTemplateManagerStep_actions__auRng";
var _2 = "BoardTemplateManagerStep_button__FFaJD";
var _3 = "BoardTemplateManagerStep_content__vMyTH";
var _4 = "BoardTemplateManagerStep_globalBadge__dMCNN";
var _5 = "BoardTemplateManagerStep_globalIcon__jhKbF";
var _6 = "BoardTemplateManagerStep_inputWrapper__+1DCb";
var _7 = "BoardTemplateManagerStep_item__EIF6L";
var _8 = "BoardTemplateManagerStep_itemHeader__OlHQp";
var _9 = "BoardTemplateManagerStep_items__BX94h";
var _a = "BoardTemplateManagerStep_meta__A2EOn";
var _b = "BoardTemplateManagerStep_metaDetails__xBcqL";
var _c = "BoardTemplateManagerStep_name__pRjoo";
var _d = "BoardTemplateManagerStep_nameText__6t2oe";
var _e = "BoardTemplateManagerStep_noTemplates__SNZAU";
export { _1 as "actions", _2 as "button", _3 as "content", _4 as "globalBadge", _5 as "globalIcon", _6 as "inputWrapper", _7 as "item", _8 as "itemHeader", _9 as "items", _a as "meta", _b as "metaDetails", _c as "name", _d as "nameText", _e as "noTemplates" }
